module.exports = __webpack_public_path__ + "img/1-3.3ef4ea45.svg";